import Vue from 'vue';


function optionEditor() {
	return {
		options: {

			indent_use_margin: true,
			language: 'es_MX',
			forced_root_block_attrs:{
				"style": "font-family: Montserrat;font-size:14px;font-style: normal;font-weight: normal; line-height: 5%"
			},
			content_css:  '/css/word.css',
			menubar: '',
			statusbar: false,
			branding: false,
			min_height: 150,
			browser_spellcheck: true,
			font_formats: 'Montserrat=Montserrat;Soberana Sans=Soberana Sans;Arial=arial,helvetica,sans-serif;Times New Roman=Times New Roman, Times, serif;',
			setup: function (ed) {
				ed.settings.paste_postprocess = function(pl, o) {
					ed.dom.setAttrib(ed.dom.select('li', o.node), 'style', 'font-family: Montserrat;font-size:14px;font-style: normal;font-weight: normal; line-height: 5%');
					ed.dom.setAttrib(ed.dom.select('p', o.node), 'style', 'font-family: Montserrat;font-size:14px;font-style: normal;font-weight: normal;word-break: break-all !important; line-height: 5%');
				}
			},
			paste_as_text: true,
			paste_text_sticky: true,
			paste_text_sticky_default: true
		},
		toolbar1: 'bold italic underline forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat ',
		toolbar2:"",
		plugins: ['placeholder','paste','copy']
	}
}

function payments_multiyears() {
    return {
        id: null,
        year: null,
        monthly: null,
        months: null,
        otherExpenses: null,
    }
}

function payments_annuals() {
    return {
        id: null,
        year: null,
        monthly: null,
        months: null,
        otherExpenses: null,
    }
}

function providersAliasTwoF() {
    return {
        format: [
            {
                type: 11,
                concept: 'Cantidad',
            },
            {
                type: 12,
                concept: 'Tipo de Equipo'
            },
            {
                type: 13,
                concept: '¿El precio de la cotización es fijo? Si/No ',
            },
            {
                type: 14,
                concept: '¿Se requiere de algún anticipo? Si/No',
            },
            {
                type: 15,
                concept: 'Indicar garantías que ofrece el proveedor',
            },
            {
                type: 16,
                concept: 'Penas que aplicará la Representación en caso de atrasos en la entrega de bienes o en la prestación del servicio o arrendamiento, por causas imputables al proveedor.',
            },
            {
                type: 17,
                concept: 'Documentos de cotización',
            },

        ]
    }
}

function providersAliasF() {
    return {
        format: [
            {
                type: 1,
                concept: 'Nombre',
            },
            {
                type: 2,
                concept: 'Vigencia del contrato en meses'
            },
            {
                type: 3,
                concept: 'Fecha propuesta de inicio',
            },
            {
                type: 4,
                concept: 'Moneda de pago',
            },
            {
                type: 5,
                concept: 'Periodicidad en el pago',
            },
            {
                type: 6,
                concept: 'Costo mensual',
            },
            {
                type: 7,
                concept: 'Subtotal 1',
            },
            {
                type: 9,
                concept: 'Gasto de instalación (en caso de aplicar)',
            },
            {
                type: 10,
                concept: 'Otros gastos (en caso de aplicar)'
            },
            {
                type: 18,
                concept: 'Impuestos (en caso de aplicar)'
            },
            {
                type: 19,
                concept: 'Subtotal 2'
            },
        ]
    }
}

function paymentsAF() {
    return [
        {
            ...payments_annuals(),
            year: 2019,
        },
        {
            ...payments_annuals(),
            year: 2020,
        },
        {
            ...payments_annuals(),
            year: 2021,
        },
        {
            ...payments_annuals(),
            year: 2022,
        },
        {
            ...payments_annuals(),
            year: 2023,
        },

    ]

}

function paymentsMF() {
    return [
        {
            ...payments_multiyears(),
            year: 2019,
        },
        {
            ...payments_multiyears(),
            year: 2020,
        },
        {
            ...payments_multiyears(),
            year: 2021,
        },
        {
            ...payments_multiyears(),
            year: 2022,
        },
        {
            ...payments_multiyears(),
            year: 2023,
        },

    ]
}

function modelTable() {
    return {
        id: null,
        name: null,
        monthlyAgreementValidity: null,
        proposedStartDate: null,
        paymentCurrency: null,
        payment_periodicity_id: null,
        monthlyCostWithTaxes: 0,
        carrierExpenses: 0,
        instalmentCosts: 0,
        anotherExpenses: 0,
        anotherExpensesAux: 0,
        anotherExpensesDescription: null,
        quantity: null,
        equipmentType: null,
        quotedPriceIsFixed: false,
        payInAdvance: false,
        providerGuarantees: null,
        penalties: null,
        cat_agreement_type_id: null,
        justification: 'El Titular de la Representación manifiesta bajo protesta de decir verdad, que el arrendamiento, adquisición o servicio solicitado es necesario para el mejor cumplimiento de las metas y objetivos de la Representación y de la SRE y hace constar que la información contenida en este documento corresponde a las cotizaciones presentadas por las empresas señaladas y que se encuentran disponibles en los archivos de esta Representación de acuerdo al articulo 16 de la LAASSP.',
        justification2: '',
        informationCircular: '',
        cat_representation_type_id: '',
        user_reviewed_profile_id: '',
        periodStart: null,
        periodEnd: null,
        monthlyCost: null,
        folioSHCP: null,
        selectionReasons: null,
        monthlyPrice: 0,
        totalPriceGoodsServices: 0,
        installationCosts: 0,
        transportationExpenses: 0,
        otherExpenses: 0,
        otherExpensesDescription: '',
        comparativeCostBenefit: null,
        acquisitionPriceGoods: null,
        acquisitionInstallationCosts: null,
        acquisitionTransportationExpenses: null,
        acquisitionOtherExpenses: 0,
        acquisitionOtherExpensesDescription: '',
        leasingMonthlyPriceGoods: null,
        leasingMonthlyInstallationCosts: null,
        leasingMonthlyTransportationExpenses: null,
        leasingMonthlyOtherExpenses: 0,
        leasingMonthlyOtherExpensesDescription: '',
        leasingMonthsPriceGoods: null,
        leasingMonthsInstallationCosts: null,
        leasingMonthsTransportationExpenses: null,
        leasingMonthsOtherExpensesDescription: '',
        leasingMonthsOtherExpenses: 0,
        leasingAnnualPriceGoods: null,
        leasingAnnualInstallationCosts: null,
        leasingAnnualTransportationExpenses: null,
        leasingAnnualOtherExpenses: 0,
        leasingAnnualOtherExpensesDescription: '',
        estimatedEconomicBenefit: null,
        economicJustification: null,
        effectivenessJustification: null,
        efficiencyJustification: null,
        impartialityJustification: null,
        honestyJustification: null,
        transparencyJustification: null,
        cat_is_there_budget_id: null,
        quantityAvailable: null,
        cat_currency_id: null,
        january: 0,
        february: 0,
        march: 0,
        april: 0,
        may: 0,
        june: 0,
        july: 0,
        august: 0,
        september: 0,
        october: 0,
        november: 0,
        december: 0,
        termsAndConditionsMultiyearJustification: null,
        conclusion: 'Por lo antes expuesto y de conformidad con el artículo 16 de la Ley de Adquisiciones, Arrendamientos y Servicios del Sector Público (LAASSP), el Titular de la Representación declara bajo protesta de decir verdad que la información remitida en el presente documento es veraz y se apega a lo señalado en el DECRETO por el que se modifica el diverso que establece las medidas para el uso eficiente, transparente y eficaz de los recursos públicos, y las acciones de disciplina presupuestaria en el ejercicio del gasto público, así como la modernización de la Administración Pública Federal. Por lo anterior, solicita se dictamine sobre la procedencia de realizar la contratación citada en el presente documento.',
        cat_agreement_multiyear_id: null,
        isActive: null,
        payments_annuals: paymentsAF(),
        payments_multiyears: paymentsMF(),
        summation: {},
        documents: [],
        equipment_types_ids: [],
        count: 0,
        // new 
        taxes: 0,
        compranetSearch: false,
        compranetSearchDescription: null,
        compranetSearchExpense: 0, 
        average: 0,
        meanMonths: 0,
        meanCosts: 0,
        meanInstallationCosts: 0,
        meanOtherExpenses: 0,
        meanSubtotal: 0,
        meanTaxes: 0,
        meanSubtotal2: 0,
        meanTotal: 0,
        averageMonths: 0,
        averageCosts: 0,
        averageInstallationCosts: 0,
        averageOtherExpenses: 0,
        averageSubtotal: 0,
        averageTaxes: 0,
        averageSubtotal2: 0,
        averageTotal: 0,
        budgetSufficiency: null,
        isMultiyear: false,
        thirdSubTotal: 0,
        thirdSubtotal2: 0,
        thirdTotal: 0,
        totalLocalCurrency: 0,
        totalMonthly: 0,
        totalMonths: 0,
        totalAnnual: 0,
        reference: 0,
        totalReference: 0
    }
}

function modelTableArray() {

    let first = Object.assign({}, modelTable());
    let second = Object.assign({}, modelTable());
    let third = Object.assign({}, modelTable());
    let four = Object.assign({}, modelTable());
    return [
        {
            ...first,
            id: 1
        },
        {
            ...second,
            id: 2
        },
        {
            ...third,
            id: 3
        },
        {
            ...four,
            id: 4
        },
    ]
}

function descriptions(){
    return {
        descriptionsArea: {}
    }
}

function formModel() {
    return {

        hash_id: null,
        last_log: {
            cat_acquisition_status_id: 1,
	        status:{
            	name : null
	        }
        },
        product_or_service_id: null,
        id: null,
        folio: null,
        name: null,
        office_ids: [],
        goals: null,
        specificObjectives: null,
        backgroundOfObjectives: null,
        validity: null,
	    validityEnd: null,
        validity_alias: null,
        scope: null,
        requirements: null,
        technicalCharacteristics: null,
        knowledgeTransfer: null,
        serviceLevels: null,
        termsAndConditions: null,
        responseTime: null,
        confidentialityClause: `Cláusula de Confidencialidad:
El proveedor reconoce que en el transcurso de los servicios proporcionados a RME de conformidad con el presente proyecto, tendrá acceso a datos, software de computadoras, así como otras informaciones relacionadas con las actividades de la RME que son confidenciales y que podrían constituir un valioso secreto comercial y de seguridad nacional. El proveedor acepta que protegerá y preservará dicha confidencialidad, así mismo acepta que no usará, modificará o revelará de modo alguno, ninguna de estas informaciones.

Asimismo, deberá mantener en estricta confidencialidad toda la información que intercambien en virtud del presente proyecto, por lo tanto, deberán abstenerse de comunicarla, publicarla o exportarla para fines distintos a los establecidos para la prestación del servicio.

En caso de que el proveedor Ganador, revele, divulgue, comparta, ceda, traspase, venda o utilice indebidamente la información que con carácter confidencial y reservada que le proporcione la RME, esta tendrá derecho de rescindir administrativamente el contrato.

El proveedor Ganador, se obliga a dejar a salvo y en paz a la RME de cualquier controversia y en su caso, cubrir los daños y perjuicios ocasionados por revelar, divulgar, compartir, ceder, traspasar, vender o utilizar indebidamente la información que, con carácter confidencial y reservada, le proporcione la RME.

Al finalizar el Servicio, el proveedor ganador deberá de eliminar la totalidad de la información proporcionada por la RME, así como la generada y la existente en sus equipos. (El proceso de eliminación será supervisado por la RME).

Así también, al finalizar el Servicio, deberá de eliminar la totalidad de la información referente a los entregables y documentación de trabajo. El proceso de eliminación deberá ejecutarse en cada uno de los equipos del  proveedor Ganador, supervisado por la RME, entregando documento con evidencia de borrado (impresión de pantalla ó reporte de herramienta usada para la eliminación).
`,
        serviceTracking: null,
        deliverables: null,
        sanctions: null,
        penalties: null,
        schedule: null,
        contractComplianceCheck: false,
        contractCompliance: null,
        paymentType: null,
        glossary: null,
        userThatReviewed: '',
        justification2: '',
        user_reviewed_profile_id: '',
        cat_adquisition_type_id: null,
        documents: [],
        articles: [],
        providers: modelTableArray(),
        provider_selected: {
            ...modelTable()
        },
        budget_id: null,
        sub_budget_id: null,
        local_currency: null,
        explanation: null,
        //new element first table of justification 2019
        old_provider_cat_agreement_type_id: null,
        old_provider_name: null,
        old_provider_period_start: null,
        old_provider_period_end: null,
        old_provider_monthly_cost: 0,
        folioSHCP: null,
        directionOfRME: null,
        coordinatesOfRME: null,
        previous_suppliers: [],
		last_log_register:{
			user:{
				full_name: null,
				office:{
					representation_name : null,
					type: {
						name: null
					},
					location: null
				},
				profile: {
					name: null
				}
			}
		},
        levels: [],
        supports: [],
        progress:[],
        calendar: [],
        background: null,
        analysis: null,
        expectedGoals: null,
        expectedBenefits: null,
        expectedRisks: null,
        operationalImpact: null,
        conclusion: null,
        costBenefitStudy: null,
        conclusionEconomicAdvantage: null,
        compranetSearch: false,
        projects: null,
        size: null,
        quantities: null,
        beforeContract: null,
        problemToSolve: null,
        developing: null,

    }
}

// Initial Object in function
function getInitialData() {
    return {
        elements: [],
        progressBar: {
            totalFields: 0,
            percentage: 0,
            totalErrors: 0
        }
    }
};


const state = {
    initial: getInitialData(),
    model: formModel(),
    onlyRead: true,
    catalogs: {
        catAcquisitionType: [],
        catAgreementType: [],
        catCurrencies: [],
        catIsThereBudgets: [],
        catAgreementMultiyear: [],
        catRepresentationTypes: [],
        catProfiles: [],
        catProductsOrServicesArticles: [],
        catBudget: [],
        catSubBudget: [],
        catPaymentPeriodicity: [],
        catEquipmentTypes: [],
        catOffice: []
    },
    providersAliasTwo: providersAliasTwoF(),
    providersAlias: providersAliasF(),
    providerActive: '',
	optionEditor: optionEditor(),
    descriptions: descriptions()
};

const mutations = {

	addYearMulti(state, payload){
		state.model.providers.forEach((item,key)=>{
			if(item.id == payload.id){
				let array = Object.assign([],item.payments_multiyears);
				if(array.length < 6){
				    console.log('arr',array.length);
                    array = array.reverse();
                    let yearTmp = array[0].year;
                    yearTmp = parseInt(yearTmp)+1;
                    state.model.providers[key].payments_multiyears.push({
                        ...payments_multiyears(),
                        year:yearTmp
                    });
                }

			}
		});
	},
    removeYearMulti(state, payload){
        state.model.providers.forEach((item,key)=>{
            if(item.id == payload.id){
                let array = item.payments_multiyears;
                if(array.length > 1){
                    array.pop();
                }else{
                   //notification error
                }


            }
        });
    },
	addYearAnnual(state, payload){
		state.model.providers.forEach((item,key)=>{

			if(item.id == payload.id){
				let array = Object.assign([],item.payments_annuals);
				array = array.reverse();
				if(array.length < 6){
                    let yearTmp = array[0].year;
                    yearTmp = parseInt(yearTmp)+1;
                    state.model.providers[key].payments_annuals.push({
                        ...payments_annuals(),
                        year:yearTmp
                    });
                }
			}
		});
	},
    removeYearAnnual(state, payload){
        state.model.providers.forEach((item,key)=>{
            if(item.id == payload.id){
                let array = item.payments_annuals;
                if(array.length > 1){
                    array.pop();
                }else{
                    //notification error
                }


            }
        });
    },
    setValue(state, payload){
        state.model.provider_selected[payload.variable] = payload.suma;

    },
    setCheckAgreementId(state){
        state.model.provider_selected.payments_multiyears.forEach((item,key) => {
            state.model.provider_selected.payments_multiyears[key].monthly = 0;
            state.model.provider_selected.payments_multiyears[key].months = 0;
            state.model.provider_selected.payments_multiyears[key].otherExpenses = 0;
        });

        state.model.provider_selected.payments_annuals.forEach((item,key) => {
            state.model.provider_selected.payments_annuals[key].monthly = 0;
            state.model.provider_selected.payments_annuals[key].months = 0;
            state.model.provider_selected.payments_annuals[key].otherExpenses = 0;
        });

    },
	setChangePeriodicity(state,payload){

		state.model.providers.forEach((item, key) => {
			if(key>0){
				state.model.providers[key].payment_periodicity_id  = null;
			}
		});
	},
	restartCalculation(state){
		state.model.providers[0].equipment_types_ids = [];// reset first providers
		state.model.providers[0].quantity = 0;// reset first providers

		state.model.providers[1].equipment_types_ids = [];// reset first providers
		state.model.providers[1].quantity = 0;// reset first providers

		state.model.providers[2].equipment_types_ids = [];// reset first providers
		state.model.providers[2].quantity = 0;// reset first providers

		let quantity = 0;
		let equipment_types_ids = [];

		state.model.articles.forEach((item) => {
			if (item.article_id) {

				let type_product_or_service_id = null;
				state.catalogs.catProductsOrServicesArticles.forEach((i)=>{
					if(i.id == item.article_id){
						state.catalogs.catEquipmentTypes.forEach((j)=>{
							if(i.type_product_or_service_id == j.id){
								type_product_or_service_id = j.id;
							}
						});
					}
				});

				equipment_types_ids.push(type_product_or_service_id);
			}
			if (item.amount !=null) {
				quantity+=parseInt(item.amount);
			}
		});

		state.model.providers[0].quantity = quantity;// set first providers
		state.model.providers[0].equipment_types_ids = equipment_types_ids;// set first providers

		state.model.providers[1].quantity = quantity;// set first providers
		state.model.providers[1].equipment_types_ids = equipment_types_ids;// set first providers

		state.model.providers[2].quantity = quantity;// set first providers
		state.model.providers[2].equipment_types_ids = equipment_types_ids;// set first providers


	},
	resetArticles(state, cat_acquisition_type_id){
		state.model.articles = [];
		if(cat_acquisition_type_id  && (cat_acquisition_type_id == 1  || cat_acquisition_type_id == 3) && state.model.product_or_service_id){

			state.model.articles.push(
				{
					"id": null,
					"article_id": state.model.product_or_service_id,
					"amount": null,
					"office_ids": [],
				}
			);
		}

	},
	resetProgressBar(state, payload) {
		state.initial.progressBar = {...payload};
	},
	resetOnlyRead(state, payload) {
		state.onlyRead = payload;
	},
	clear(state) {
		state.initial = getInitialData();
		state.model = formModel();
		state.onlyRead = false;
		state.catalogs = {
			catAcquisitionType: [],
			catAgreementType: [],
			catCurrencies: [],
			catIsThereBudgets: [],
			catAgreementMultiyear: [],
			catRepresentationTypes: [],
			catProfiles: [],
			catProductsOrServicesArticles: [],
			catBudget: [],
			catSubBudget: [],
			catPaymentPeriodicity: [],
			catEquipmentTypes: [],
			catOffice:[]
		};
		state.optionEditor =  optionEditor();
		state.providersAliasTwo = providersAliasTwoF();
		state.providersAlias = providersAliasF();
		// merge providers
		state.providerActive = '';
	},
	fetchSingleSuccess(state, response, commit) {
		let {acquisitions} = response;
		let acquisitionsTmp = acquisitions;
		if(!acquisitionsTmp.provider_selected){
			acquisitionsTmp.provider_selected =  {
			...modelTable()
			};
		}else{
			acquisitionsTmp.provider_selected.quotedPriceIsFixed = parseInt(acquisitionsTmp.provider_selected.quotedPriceIsFixed) ? true : false;
            acquisitionsTmp.provider_selected.payInAdvance  = parseInt(acquisitionsTmp.provider_selected.payInAdvance) ? true : false;
			acquisitionsTmp.provider_selected.compranetSearch  = parseInt(acquisitionsTmp.provider_selected.compranetSearch) ? true : false;
			state.providerActive = acquisitionsTmp.provider_selected.id;
		}
		acquisitionsTmp.providers.forEach((item)=>{
			if(item.payments_annuals.length==0){
				item.payments_annuals = paymentsAF();
			}
			if(item.payments_multiyears.length==0){
				item.payments_multiyears = paymentsMF();
			}
		});
		state.providersAliasTwo = providersAliasTwoF();
		state.providersAlias = providersAliasF();
		if(acquisitionsTmp.last_log.cat_acquisition_status_id == 1
            || acquisitionsTmp.last_log.cat_acquisition_status_id == 3
            || acquisitionsTmp.last_log.cat_acquisition_status_id == 6
            || acquisitionsTmp.last_log.cat_acquisition_status_id == 9
            || acquisitionsTmp.last_log.cat_acquisition_status_id == 32
            || acquisitionsTmp.last_log.cat_acquisition_status_id == 50
            || acquisitionsTmp.last_log.cat_acquisition_status_id == 51
            || acquisitionsTmp.last_log.cat_acquisition_status_id == 52
            || acquisitionsTmp.last_log.cat_acquisition_status_id == 55
            || acquisitionsTmp.last_log.cat_acquisition_status_id == 59){
			state.onlyRead = false;
		}else{
            state.onlyRead = true;
        }
		acquisitionsTmp.providers.forEach((item, key) => {
			acquisitionsTmp.providers[key].quotedPriceIsFixed = parseInt(item.quotedPriceIsFixed) ? true : false;
            acquisitionsTmp.providers[key].payInAdvance  = parseInt(item.payInAdvance) ? true : false;
			acquisitionsTmp.providers[key].compranetSearch  = parseInt(item.compranetSearch) ? true : false;
            
		});
		acquisitionsTmp.contractComplianceCheck  = parseInt(acquisitionsTmp.contractComplianceCheck) ? true : false;
		state.model = acquisitionsTmp;
	},
    commitDescriptions(state, response, commit){
	    state.descriptions = response.descriptions
    },


	addPreviosSuppliers(state) {
		state.model.previous_suppliers.push(
			{
				"id": null,
				"old_provider_cat_agreement_type_id": null,
				"old_provider_name": null,
				"old_provider_period_start": null,
				"old_provider_period_end": null,
				"old_provider_monthly_cost": 0,
				"folioSHCP": null
			}
		);
	},

	addDoc(state, payload) {
		state.model.documents.push(
			{
				"id": null,
				"file_id": payload.file_id,
				"document_type_id": null,
				"section_id" : payload.section_id,
				"isActive": true,
				"fileName": payload.fileName,
				"description" : null
			}
		);
	},
	addDocToProvider(state, paylo) {


		let index = state.model.providers.indexOf(paylo.item);
		state.model.providers[index].documents.push(
			{
				"id": null,
				"file_id": paylo.payload.file_id,
				"document_type_id": null,
				"provider_id" : paylo.payload.provider_id,
				"fileName": paylo.payload.fileName,
				"description" : null
			}
		);

	},
	addProductService(state) {
		state.model.articles.push(
			{
				"id": null,
				"article_id": null,
				"amount": null,
				"describeAnotherName" : null,
				"particularDescription" : null,
				"technicalDescription" : null,
				"searchCompranet" : null,
                "mean" : null,
                "costProv1": null,
                "costProv2": null,
                "costProv3": null,
				"totalAmount": null,
				"totalProv1": null,
				"totalProv2": null,
				"totalProv3": null,
				"totalSearchCompranet": null,
				"totalMean": null,
				"isHidden": false,

			}
		);
	},


	removeProductService(state, payload){
		let index = state.model.articles.indexOf(payload);
		state.model.articles.splice(index, 1);
	},

	removeDocument(state, payload) {
		let index = state.model.documents.indexOf(payload);
		state.model.documents.splice(index, 1);
	},
	removePreviousSupplier(state, payload) {
		let index = state.model.previous_suppliers.indexOf(payload);
		state.model.previous_suppliers.splice(index, 1);
	},

	removeDocumentToProvider(state, {item, payload}) {
		let index = state.model.providers.indexOf(item);
		let index2 = state.model.providers[index].documents.indexOf(payload);
		state.model.providers[index].documents.splice(index2, 1);

	},
	loadCatalogSuccess(state, response) {
		const {data} = response;
		state.catalogs = data;

	},
	selectedProvider(state, payload){


		state.model.providers.forEach((item)=>{
			if(item.id == payload){
				item.isActive = true;
			}else{
				item.isActive = false;
			}
		});
		state.model.provider_selected = {};

		let first = window._.head(state.model.providers.filter((item)=>item.isActive));


		if(!first){
			state.model.provider_selected =  {
				...modelTable()
			};
		}else{
			state.model.provider_selected = first;
		}
	},
	setStatusProviderActive(state, payload){
		state.providerActive = payload;
	},
	setProviderSelected(state, payload){

		state.model.providers.forEach((item,key)=>{
			if(item.id == payload.id){
				/*state.model.providers[key] = payload*/

                Vue.set(state.model.providers,key,payload);

			}
		});
	},
    addLevel(state, payload){
        state.model.levels.push({
            id: null,
            acquisition_id: null,
            level: null,
            concept: null,
        });
    },

    removeLevel(state, payload){
        let index = state.model.levels.indexOf(payload);
        state.model.levels.splice(index, 1);
    },

    addSupport(state, payload){
        state.model.supports.push({
            id: null,
            acquisition_id: null,
            concept: null,
            response: null,
        });
    },

    removeSupport(state, payload){
        let index = state.model.supports.indexOf(payload);
        state.model.supports.splice(index, 1);
    },
    addDeliverable(state, payload){
        state.model.progress.push({
            id: null,
            acquisition_id: null,
            deliverable: null,
            concept: null,
            periodicity: null,
        });
    },

    removeDeliverable(state, payload){
        let index = state.model.progress.indexOf(payload);
        state.model.progress.splice(index, 1);
    },
    addCalendar(state, payload){
        state.model.calendar.push({
            id: null,
            acquisition_id: null,
            activity: null,
            startDate: null,
            endDate: null,
            responsible: null,
        });
    },

    removeCalendar(state, payload){
        let index = state.model.calendar.indexOf(payload);
        state.model.calendar.splice(index, 1);
    },

};

const actions = {

    setProviderActive2({state, commit}, providerActive) {
        commit('setStatusProviderActive', providerActive);
    },

    fetchDescriptions({state, commit, dispatch}){
        dispatch('loading/spinner', {msg: 'Cargando Información...', status: true}, {root: true});

        return axios.get(`/api/acquisitions/g-description`)
            .then((res) => {
                dispatch('loading/spinner', {}, {root: true});

                const parsedResponse = res.data;
                if (parsedResponse) {
                    commit('commitDescriptions', parsedResponse);
                    return parsedResponse;
                } else {
                    return Promise.reject(parsedResponse);
                }

            })
            .catch((err) => {
                console.log(err);
                dispatch('loading/spinner', {}, {root: true});
                let msg = 'No se pudo completar la acción';
                if (err.response &&
                    err.response.data &&
                    err.response.data.message
                    && err.response.status == 400) {
                    msg = err.response.data.message;
                }
                dispatch('notifications/error', {msg: msg}, {root: true});
                return Promise.reject(err);

            });
    },


    fetchSigle({state, commit, dispatch}, {crypt_id} = {}) {

        dispatch('loading/spinner', {msg: 'Cargando Información...', status: true}, {root: true});

        return axios.get(`/api/acquisitions/service/${crypt_id}/edit`)
            .then((res) => {
                dispatch('loading/spinner', {}, {root: true});

                const parsedResponse = res.data;
                if (parsedResponse) {
                    commit('fetchSingleSuccess', parsedResponse);
                    return parsedResponse;
                } else {
                    return Promise.reject(parsedResponse);
                }

            })
            .catch((err) => {
                console.log(err);
                dispatch('loading/spinner', {}, {root: true});
                let msg = 'No se pudo completar la acción';
                if (err.response &&
                    err.response.data &&
                    err.response.data.message
                    && err.response.status == 400) {
                    msg = err.response.data.message;
                }
                dispatch('notifications/error', {msg: msg}, {root: true});
                return Promise.reject(err);

            });
    },

    loadCatalog({state, commit, dispatch}, payload) {

        let url = '/api/acquisitions/catalogs';

        return window.axios.get(`${url}`, {params: null})

            .then((res) => {
                const parsedResponse = res.data;
                if (parsedResponse) {
                    commit('loadCatalogSuccess', parsedResponse);
                    return parsedResponse;
                } else {
                    return Promise.reject(parsedResponse);
                }
            })
            .catch((err) => {
                console.log(err);
                dispatch('loading/spinner', {}, {root: true});
                let msg = 'No se pudo completar la acción';
                if (err.response &&
                    err.response.data &&
                    err.response.data.message
                    && err.response.status == 400) {
                    msg = err.response.data.message;
                }
                dispatch('notifications/error', {msg: msg}, {root: true});
                return Promise.reject(err);
            });
    },
    initService({commit, dispatch}, payload) {
        let array_dispatch = [];
        array_dispatch.push(dispatch('loadCatalog'));

        dispatch('loading/spinner', {msg: 'Cargando Datos...', status: true}, {root: true});


        return Promise.all(array_dispatch)
            .then(() => {
                dispatch('loading/spinner', {}, {root: true});
            })
            .catch((err) => {
                console.log(err);
                dispatch('loading/spinner', {}, {root: true});
                let msg = 'No se pudo completar la acción';
                if (err.response &&
                    err.response.data &&
                    err.response.data.message
                    && err.response.status == 400) {
                    msg = err.response.data.message;
                }
                dispatch('notifications/error', {msg: msg}, {root: true});
                return Promise.reject(err);
            });
    },
};

const getters = {
    requestForm: state => state.model,
    catalogs: state => state.catalogs,
    general: state => state,
    onlyRead: state => state.onlyRead,
    progressBar: state => state.initial.progressBar,
    providerActive: state => state.providerActive,
	optionEditor:  state => state.optionEditor,
    providersDocumentsAlias: state => state.model.providers,
    descriptionsAreas: state => state.descriptions
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};

